import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { push } from 'react-router-redux';
import { withRouter } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { List } from 'immutable';

import { getUser } from '../User/actions';
import { getCianRedirectUrl } from '../Home/actions';
import { setSection } from '../Dictionaries/actions';
import {
  resetFilter, updateFilter, setFilterByLocation,
  loadFavorites, fetchFavorites
} from './actions';
import { pureFilter } from '../../utils/urls';
import getDictionary from '../../utils/dictionaries';
import { getFavoritesStatistic, getDealTypeSections } from '../../utils/section';
import connectDataFetchers from '../../lib/connectDataFetchers';

import ReactPaginate from 'react-paginate';
import { ScrollToTopOnMount } from '../../ui/Common';
import { FlexView } from '../../ui/Views/Announcements';
import FavoritesHeader from '../../ui/Header/FavoritesHeader';
import { ScrollUp } from '../../ui/Controls';

import {
  SALE,
  APARTMENTS,
  ADFOX,
  RENT,
} from '../../consts';
import api from '../../apiSingleton';
import AdFoxFactory from '../../ui/AdFox/AdFoxFactory';
import { getFlexItem } from '../../classes/builder/search/flexListBuilder';
import GtagBuilder from '../../classes/builder/gtagEventBuilder';
import {
  gtagPushEventNewPage,
  getCustomUrlCian
} from '../../utils/googleAnalytics';

class Favorites extends Component {
  constructor (props, match) {
    super(props);

    this.state = {
      isDeleting: false
    };

    const statistic = props.user.getIn(['data', 'favoritesStatistics'], new List()).toJS();
    const defaultRubric = getFavoritesStatistic(statistic).filter(tab => tab[2]);

    this.defaultRentRubric = defaultRubric.length && defaultRubric.filter(item => item[3].includes('rent')).length ?
      defaultRubric.filter(item => item[3].includes('rent'))[0] : ['rentApartments', 'Аренда квартир, комнат', 0, RENT, APARTMENTS];
    this.defaultSaleRubric = defaultRubric.length && defaultRubric.filter(item => item[3].includes('sale')).length ?
      defaultRubric.filter(item => item[3].includes('sale'))[0] : ['saleApartments', 'Продажа квартир, комнат', 0, SALE, APARTMENTS];

    this.dealType = props.match.params.dealType || (defaultRubric.length ? defaultRubric[0][3] : SALE);
    this.realtyType = props.match.params.realtyType || (defaultRubric.length ? defaultRubric[0][4] : APARTMENTS);
    this.seoTitle = 'Избранное';
    this.seoDescription = '';

    this.initSection(this.dealType, this.realtyType);

    this.handlerRemoveAll = this.handlerRemoveAll.bind(this);
    this.handlerUpdateSort = this.handlerUpdateSort.bind(this);
    this.handlerAddFavorites = this.handlerAddFavorites.bind(this);
    this.handlerRemoveFavorites = this.handlerRemoveFavorites.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.handlerClickAnnouncement = this.handlerClickAnnouncement.bind(this);
    this.handlerShowContacts = this.handlerShowContacts.bind(this);
    this.flexItem = getFlexItem(this.dealType, this.realtyType);
  }

  initSection (dealType, realtyType) {
    this.dealType = dealType;
    this.realtyType = realtyType;
  }

  handlerRemoveAll () {
    if (confirm('Удалить все избранное?')) {
      this.setState({
        isDeleting: true
      });

      const userId = this.props.user.getIn(['data', 'id']);
      api.user
        .favoritesDeleteAll(userId)
        .then((resp) => {
          window.location.href = '/favorites/';
        });
    }
  }

  handlerUpdateSort (e) {
    this.props.updateFilter({sort: e.target.dataset.sortkey});
    const filter = pureFilter(this.props.filter).toJS();
    this.props.loadFavorites(this.dealType, this.realtyType, filter);
  }

  onPageChange (paginator) {
    const filter = this.props.filter;
    const page = (parseInt(paginator.selected) || 0) + 1;

    this.props.updateFilter({page});
    this.props.loadFavorites(this.dealType, this.realtyType, pureFilter(filter.set('page', page)).toJS());
  }

  goTo (dealType, realtyType) {
    this.initSection(dealType, realtyType);
    this.props.setSection(this.dealType, this.realtyType);

    const filter = pureFilter(this.props.filter.set('page', 1)).toJS();
    this.props.dispatch(push(`/favorites/${dealType}/${realtyType}/`));
    this.props.loadFavorites(dealType, realtyType, filter);
  }

  componentDidMount () {
    this.initSection(this.dealType, this.realtyType);
    this.props.setSection(this.dealType, this.realtyType);
    if ((!this.props.user.getIn(['data', 'id'])) ||
        (this.props.user.getIn(['data', 'id']) && this.props.favoriteList.size)) {
      const cianGtagEvent = new GtagBuilder({})
        .setEvent('newpage')
        .setEventCategory('page')
        .setEventAction('newpage')
        .setEventLabel('open')
        .setUser(this.props.user)
        .setPage({
          pageType: 'ListingFavorites',
          siteType: 'desktop',
          listingType: 'list',
          sortType: 'default',
          offersQty: this.props.meta.get('totalCount'),
          pageNumber: Number(this.props.meta.get('currentPage'))
        })
        .setProducts(this.props.favoriteList)
        .getEvent();
      gtagPushEventNewPage(cianGtagEvent);
    }
  }

  componentDidUpdate (prevProps, prevState, prevContext) {
    ReactTooltip.rebuild();
  }

  componentWillUnmount () {
    this.props.resetFilter();
  }

  renderSeo () {
    const meta = this.props.meta;
    const title = meta && meta.get('seoTitle');
    const description = meta && meta.get('seoDescription');

    return (
      <Helmet
        htmlAttributes={{ lang: 'ru' }}
        title={title || this.seoTitle}
        meta={[
          {
            'name': 'description',
            'content': description || this.seoDescription
          }
        ]}
      />
    );
  }

  renderWelcome () {
    return (
      <div className='page-top-separator page-favorites page-favorites-welcome'>
        <div className='message-welcome'>
          Для добавления объявления в избранное необходимо авторизоваться или зарегистрироваться.
          <br />
          Это позволит вам видеть один и тот же список на любых ваших устройствах.
        </div>
        <div className='register-btns'>
          <div className='controls'>
            <a href='/user/default/login/' className='btn btn-primary'>Войти</a>
            <a href='/user/default/registration/' className='btn btn-secondary'>Зарегистрироваться</a>
          </div>
        </div>
      </div>
    );
  }

  getTabsByDealType () {
    const statistic = this.props.user.getIn(['data', 'favoritesStatistics'], new List()).toJS();
    const favoriteTabs = getFavoritesStatistic(statistic, true);
    const currentDealType = this.dealType.includes('rent') ? 'rent' : 'sale';

    return favoriteTabs.filter(item => item[3].includes(currentDealType));
  }

  getTabs () {
    const statistic = this.props.user.getIn(['data', 'favoritesStatistics'], new List()).toJS();

    return getFavoritesStatistic(statistic, true);
  }

  getDealTypeTabs () {
    const statistic = this.props.user.getIn(['data', 'favoritesStatistics'], new List()).toJS();

    return getDealTypeSections(statistic, false);
  }

  handlerClickAnnouncement (announcement) {
    const cianGtagEvent = new GtagBuilder({})
      .setEvent('oldevent')
      .setEventCategory('Listing')
      .setEventAction('to_card')
      .setEventLabel('from_listing')
      .setUser(this.props.user)
      .setPage({
        pageType: 'ListingFavorites',
        siteType: 'desktop',
        listingType: 'list',
        sortType: 'default',
        offersQty: this.props.meta.get('totalCount'),
        pageNumber: Number(this.props.meta.get('currentPage'))
      })
      .setProducts(new List([announcement]))
      .getEvent();
    gtagPushEventNewPage(cianGtagEvent);
  }

  handlerShowContacts (announcement) {
    const cianGtagEvent = new GtagBuilder({})
      .setEvent('oldevent')
      .setEventCategory('Phones')
      .setEventAction('Open_listing')
      .setEventLabel(getCustomUrlCian(announcement))
      .setUser(this.props.user)
      .setPage({
        pageType: 'ListingFavorites',
        siteType: 'desktop',
        listingType: 'list',
        sortType: 'default',
        offersQty: this.props.meta.get('totalCount'),
        pageNumber: Number(this.props.meta.get('currentPage'))
      })
      .setProducts(new List([announcement]))
      .getEvent();
    gtagPushEventNewPage(cianGtagEvent);
  }

  handlerAddFavorites (announcement) {
    const cianGtagEvent = new GtagBuilder({})
      .setEvent('oldevent')
      .setEventCategory('favorite')
      .setEventAction('add_from_list')
      .setEventLabel(getCustomUrlCian(announcement))
      .setUser(this.props.user)
      .setPage({
        pageType: 'ListingFavorites',
        siteType: 'desktop',
        listingType: 'list',
        sortType: 'default',
        offersQty: this.props.meta.get('totalCount'),
        pageNumber: Number(this.props.meta.get('currentPage'))
      })
      .setProducts(new List([announcement]))
      .getEvent();
    gtagPushEventNewPage(cianGtagEvent);
  }

  handlerRemoveFavorites (announcement) {
    const cianGtagEvent = new GtagBuilder({})
      .setEvent('oldevent')
      .setEventCategory('favorite')
      .setEventAction('remove_from_list')
      .setEventLabel(getCustomUrlCian(announcement))
      .setUser(this.props.user)
      .setPage({
        pageType: 'ListingFavorites',
        siteType: 'desktop',
        listingType: 'list',
        sortType: 'default',
        offersQty: this.props.meta.get('totalCount'),
        pageNumber: Number(this.props.meta.get('currentPage'))
      })
      .setProducts(new List([announcement]))
      .getEvent();
    gtagPushEventNewPage(cianGtagEvent);
  }


  render () {
    const { domain, user } = this.props;
    const regionName = domain.get('domain', '') || '';

    if (!user.getIn(['data', 'id'])) {
      return this.renderWelcome();
    }

    const tabs = this.getTabs();
    const tabsByDealType = this.getTabsByDealType();
    const dealTypeTabs = this.getDealTypeTabs();
    const factory = AdFoxFactory(regionName);
    const adFoxEl1 = factory.getByPosition(ADFOX.favoritesPage_1);
    const adFoxEl2 = factory.getByPosition(ADFOX.favoritesPage_2);

    return (
      <div className='page-top-separator page-favorites'>
        { this.renderSeo() }
        <ScrollToTopOnMount />

        <section className='search-result'>
          <div className='search-result__header'>
            <FavoritesHeader totalCount={tabs.reduce((i, n) => i + n[2], 0)} />

            <div className='deal-type-list btn-group-pills'>
              {dealTypeTabs.map((tab, index) => {
                return <a
                  className={'btn btn-base' + (this.dealType.includes(tab[0]) ? ' pressed' : '')}
                  href={`/favorites/${tab[0] === 'sale' ?
                    this.defaultSaleRubric[3] : this.defaultRentRubric[3] }/${tab[0] === 'sale' ?
                    this.defaultSaleRubric[4] : this.defaultRentRubric[4] }`
                  }
                  key={index}
                  onClick={(e) => {
                    e.preventDefault();
                    this.goTo(tab[0] === 'sale' ?
                    this.defaultSaleRubric[3] : this.defaultRentRubric[3],
                    tab[0] === 'sale' ?
                    this.defaultSaleRubric[4] : this.defaultRentRubric[4]);
                  }}>
                  {tab[1]}
                  <div className={'bandage-count' + (this.dealType.includes(tab[0]) ? ' pressed' : '')}>
                    {tab[2]}
                  </div>
                </a>;
              })}
            </div>
            {!!tabsByDealType.length &&
              <div className='rubric-list btn-group-pills'>
                {tabsByDealType.map((tab, index) => {
                  return <a
                    className={'btn btn-base' + (tab[3] === this.dealType && tab[4] === this.realtyType ? ' pressed' : '')}
                    href={'/favorites/' + tab[3] + '/' + tab[4]}
                    key={index}
                    onClick={(e) => {
                      e.preventDefault();
                      this.goTo(tab[3], tab[4]);
                    }}>
                    {tab[1]}
                    <div className={'bandage-count'+ (tab[3] === this.dealType && tab[4] === this.realtyType ? ' pressed' : '')}>
                      {tab[2]}
                    </div>
                  </a>;
                })}
              </div>
            }
          </div>

          {
            this.props.favoriteList.size || this.props.favoriteLoading
              ? (
                <div>
                  {
                    !!this.props.favoriteList.size && (
                      <div className='favorites-control-wrp'>
                        <div className='pagination-wrp pagination-top'>
                          <ReactPaginate
                            onPageChange={this.onPageChange}
                            pageCount={this.props.meta.get('pageCount')}
                            initialPage={this.props.meta.get('currentPage') - 1}
                            forcePage={this.props.meta.get('currentPage') - 1}
                            disableInitialCallback
                            previousLabel={
                              (
                                <Fragment>
                                  <span className="icon-arrow-left-new"></span>
                                  <span>В начало</span>
                                </Fragment>
                              )
                            }
                            nextLabel={
                              (
                                <Fragment>
                                  <span>Следующая</span>
                                  <span className="icon-arrow-right-new"></span>
                                </Fragment>
                              )
                            }
                          />
                        </div>
                        {
                          this.state.isDeleting ? (
                            <button disabled className='btn-base btn-primary btn-clear-favorites processed'>Удаление ...</button>
                          ) : (
                            <button onClick={this.handlerRemoveAll} className='btn-base btn-primary btn-clear-favorites'>Очистить все избранное</button>
                          )
                        }
                      </div>
                    )
                  }

                  {!this.props.favoriteLoading && adFoxEl1}

                <FlexView
                  flexItem={this.flexItem}
                  isLoading={this.props.favoriteLoading}
                  data={this.props.favoriteList}
                  dealType={this.dealType}
                  realtyType={this.realtyType}
                  domain={domain}
                  user={user}
                  dictionary={this.props.dictionary}
                  onUpdateFilter={this.props.updateFilter}
                  disableSortHeader

                  sortKey={this.props.filter.get('sort')}
                  onSort={this.handlerUpdateSort}

                  eventAddFavoritesForCian={this.handlerAddFavorites}
                  eventRemoveFavoritesForCian={this.handlerRemoveFavorites}
                  eventClickAnnouncement={this.handlerClickAnnouncement}
                  eventShowContacts={this.handlerShowContacts}

                />

                  {
                    !!this.props.favoriteList.size && (
                      <div className='pagination-wrp'>
                        <ReactPaginate
                          onPageChange={this.onPageChange}
                          pageCount={this.props.meta.get('pageCount')}
                          initialPage={this.props.meta.get('currentPage') - 1}
                          forcePage={this.props.meta.get('currentPage') - 1}
                          disableInitialCallback
                          previousLabel={
                            (
                              <Fragment>
                                <span className="icon-arrow-left-new"></span>
                                <span>В начало</span>
                              </Fragment>
                            )
                          }
                          nextLabel={
                            (
                              <Fragment>
                                <span>Следующая</span>
                                <span className="icon-arrow-right-new"></span>
                              </Fragment>
                            )
                          }
                        />
                      </div>
                    )
                  }

                  {!this.props.favoriteLoading && adFoxEl2}
                </div>
              )
              : (
                <div className='empty-result'>
                  нет избранных объявлений
                </div>
              )
          }
        </section>

        <ScrollUp showUnder={500} />
      </div>
    );
  };
}

Favorites.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.object
  }).isRequired,

  domain: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,

  dictionary: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  favoriteList: PropTypes.object.isRequired,
  favoriteLoading: PropTypes.bool,
  meta: PropTypes.object,

  dispatch: PropTypes.func.isRequired,
  resetFilter: PropTypes.func.isRequired,
  updateFilter: PropTypes.func.isRequired,
  loadFavorites: PropTypes.func.isRequired,
  setSection: PropTypes.func.isRequired
};

Favorites.defaultProps = {
  favoriteLoading: true,
  meta: {}
};

function mapStateToProps (state) {
  const favorites = state.get('favorites');

  return {
    domain: state.get('domain'),
    user: state.get('user'),
    filter: favorites.get('filter'),
    meta: favorites.get('meta'),
    favoriteList: favorites.get('favoriteList').map(v => v.get('object')),
    favoriteLoading: favorites.get('loading'),
    dictionary: getDictionary(state.get('dictionaries'))
  };
}

function mapDispatchToProps (dispatch) {
  const actions = bindActionCreators({
    getUser,
    setSection,
    loadFavorites,
    updateFilter,
    resetFilter
  }, dispatch);

  actions.dispatch = dispatch;
  return actions;
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
  connectDataFetchers(Favorites, [getUser, setFilterByLocation, fetchFavorites, getCianRedirectUrl])
));



// WEBPACK FOOTER //
// ./src/app/Favorites/Favorites.jsx